import { ColorConstants } from '@shared/constants';
import { GetPathnameFromChoices } from '@domain/campaigns/campaigns.types';

export const CAMPAIGNS_TEST_ID = {
    DASHBOARD_TABLE_CAMPAIGN: 'table-campaign',
    CAMPAIGN_TABLE_PAGESIZE: 'pagesize-selector',
    PAGINATION: {
        PREVIOUS_PAGE_BUTTON: 'pagination-button-previous',
        NEXT_PAGE_BUTTON: 'pagination-button-next',
    },
};

export enum CAMPAIGN_STATUS {
    ACTIVE = 'active',
    PAUSED = 'paused',
    ENABLED = 'enabled',
    ENDED = 'ended',
    REMOVED = 'removed',
}

export const CAMPAIGN_STATUS_COLOR = {
    enabled: ColorConstants.shamrock,
    paused: ColorConstants.salmon,
    removed: ColorConstants.silver,
    campaign_paused: ColorConstants.salmon,
    active: ColorConstants.shamrock,
    ended: ColorConstants.silver,
};

export const getPathnameFromChoices: GetPathnameFromChoices = {
    STATE: 'state',
    ACTION: 'action',
};
